/**
 * Illustrative leaderboard data for soft-UI leaderboards (demo / until APIs).
 */

const missionHistoryPilot = [
  {
    date: "Mar 28, 2026",
    label: "Patient Transport — Tucson → Phoenix",
    points: "+480",
    hours: "7.2 h",
    status: "complete",
  },
  {
    date: "Mar 22, 2026",
    label: "Supply Drop — Nogales Clinic",
    points: "+412",
    hours: "6.1 h",
    status: "complete",
  },
  {
    date: "Mar 30, 2026",
    label: "Emergency Med Transport — Flagstaff",
    points: "+520",
    hours: "8.4 h",
    status: "active",
  },
  {
    date: "Mar 15, 2026",
    label: "Wildfire Relief — Payson Base Camp",
    points: "+390",
    hours: "5.8 h",
    status: "complete",
  },
  {
    date: "Apr 2, 2026",
    label: "Habitat Survey — Verde Valley",
    points: "—",
    hours: "—",
    status: "pending",
  },
];

const comparePilot = {
  missions: [
    { label: "This pilot", widthPct: 90, value: "28" },
    { label: "Network Avg", widthPct: 42, value: "13", variant: "avg" },
    { label: "Top 10%", widthPct: 74, value: "23", variant: "top" },
  ],
  score: [
    { label: "This pilot", widthPct: 95, value: "12K" },
    { label: "Network Avg", widthPct: 38, value: "4.6K", variant: "avg" },
    { label: "Top 10%", widthPct: 72, value: "9.2K", variant: "top" },
  ],
};

const badgesPilot = [
  { icon: "🏅", name: "25 Missions", sub: "Milestone" },
  { icon: "⚡", name: "Top Scorer", sub: "March 2026" },
  { icon: "🌟", name: "150h Donated", sub: "Milestone" },
  { icon: "🚑", name: "Lifesaver", sub: "Medical Missions" },
];

export const leaderboardPeriodOptions = [
  "All Time",
  "This Month",
  "This Quarter",
  "This Year",
];

export const pilotTabStats = [
  {
    icon: "✈️",
    variant: "info",
    label: "Active Pilots",
    value: "142",
    delta: "↑ 12 this month",
  },
  {
    icon: "🕐",
    variant: "success",
    label: "Total Hours Donated",
    value: "3.4K",
    delta: "↑ 8% vs last quarter",
  },
  {
    icon: "🎯",
    variant: "warning",
    label: "Missions Flown",
    value: "512",
    delta: "↑ 47 this month",
  },
  {
    icon: "⭐",
    variant: "dark",
    label: "Avg Score",
    value: "7,240",
    delta: "↑ 432 pts avg",
  },
];

export const airportTabStats = [
  {
    icon: "🛬",
    variant: "info",
    label: "Partner Airports",
    value: "22",
    delta: "↑ 3 this quarter",
  },
  {
    icon: "⛽",
    variant: "success",
    label: "Fuel Donated (gal)",
    value: "48K",
    delta: "↑ 12% vs last quarter",
  },
  {
    icon: "🎯",
    variant: "warning",
    label: "Missions Supported",
    value: "198",
    delta: "↑ 22 this month",
  },
  {
    icon: "⭐",
    variant: "dark",
    label: "Avg Score",
    value: "8,510",
    delta: "↑ 640 pts avg",
  },
];

export const nonprofitTabStats = [
  {
    icon: "🏥",
    variant: "info",
    label: "Nonprofit Partners",
    value: "34",
    delta: "↑ 5 this quarter",
  },
  {
    icon: "🚑",
    variant: "success",
    label: "Patients Transported",
    value: "1,204",
    delta: "↑ 23% vs last month",
  },
  {
    icon: "🎯",
    variant: "warning",
    label: "Missions Coordinated",
    value: "287",
    delta: "↑ 34 this month",
  },
  {
    icon: "⭐",
    variant: "dark",
    label: "Avg Score",
    value: "9,180",
    delta: "↑ 780 pts avg",
  },
];

export const demoPilots = [
  {
    id: "p1",
    rank: 1,
    name: "Capt. Sarah Mendes",
    sub: "Cessna 182 · IFR Rated",
    missions: "28",
    hours: "186 h",
    avgPts: "432",
    score: "12,096",
    location: "Tucson, AZ",
    rankLabel: "#1 in Network",
    scoreDelta: "↑ +842 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "28",
          sub: "↑ 4 this month",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "186 h",
          sub: "↑ 22 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "432",
          sub: "↑ 18 above network avg",
        },
      ],
      missions: missionHistoryPilot,
      compare: comparePilot,
      badges: badgesPilot,
      compareShortName: "Sarah",
    },
  },
  {
    id: "p2",
    rank: 2,
    name: "Marcus J. Okoye",
    sub: "Piper Seneca · Multi-Engine",
    missions: "24",
    hours: "161 h",
    avgPts: "418",
    score: "10,032",
    location: "Phoenix, AZ",
    rankLabel: "#2 in Network",
    scoreDelta: "↑ +620 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "24",
          sub: "↑ 2 this month",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "161 h",
          sub: "↑ 14 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "418",
          sub: "↑ 8 above network avg",
        },
      ],
      missions: missionHistoryPilot,
      compare: {
        missions: [
          { label: "This pilot", widthPct: 78, value: "24" },
          { label: "Network Avg", widthPct: 42, value: "13", variant: "avg" },
          { label: "Top 10%", widthPct: 74, value: "23", variant: "top" },
        ],
        score: [
          { label: "This pilot", widthPct: 80, value: "10K" },
          { label: "Network Avg", widthPct: 38, value: "4.6K", variant: "avg" },
          { label: "Top 10%", widthPct: 72, value: "9.2K", variant: "top" },
        ],
      },
      badges: badgesPilot.slice(0, 3),
      compareShortName: "Marcus",
    },
  },
  {
    id: "p3",
    rank: 3,
    name: "Elena Vasquez",
    sub: "Cirrus SR22 · ATP",
    missions: "21",
    hours: "143 h",
    avgPts: "401",
    score: "8,421",
    location: "Albuquerque, NM",
    rankLabel: "#3 in Network",
    scoreDelta: "↑ +410 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "21",
          sub: "↑ 3 this month",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "143 h",
          sub: "↑ 11 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "401",
          sub: "On par with network avg",
        },
      ],
      missions: missionHistoryPilot,
      compare: comparePilot,
      badges: badgesPilot.slice(1, 4),
      compareShortName: "Elena",
    },
  },
  {
    id: "p4",
    rank: 4,
    name: "David Nguyen",
    sub: "Beechcraft Bonanza · IFR",
    missions: "18",
    hours: "124 h",
    avgPts: "395",
    score: "7,110",
    location: "Denver, CO",
    rankLabel: "#4 in Network",
    scoreDelta: "↑ +290 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "18",
          sub: "↑ 1 this month",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "124 h",
          sub: "↑ 6 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "395",
          sub: "Slightly below top 10%",
        },
      ],
      missions: missionHistoryPilot,
      compare: comparePilot,
      badges: [badgesPilot[2], badgesPilot[3]],
      compareShortName: "David",
    },
  },
  {
    id: "p5",
    rank: 5,
    name: "Amara Diallo",
    sub: "Mooney M20 · Commercial",
    missions: "15",
    hours: "108 h",
    avgPts: "378",
    score: "5,670",
    location: "Salt Lake City, UT",
    rankLabel: "#5 in Network",
    scoreDelta: "↑ +180 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "15",
          sub: "Steady",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "108 h",
          sub: "↑ 5 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "378",
          sub: "Growing",
        },
      ],
      missions: missionHistoryPilot,
      compare: comparePilot,
      badges: [badgesPilot[0]],
      compareShortName: "Amara",
    },
  },
  {
    id: "p6",
    rank: 6,
    name: "Tom Redcloud",
    sub: "Cessna 210 · IFR",
    missions: "13",
    hours: "89 h",
    avgPts: "354",
    score: "4,602",
    location: "Billings, MT",
    rankLabel: "#6 in Network",
    scoreDelta: "↑ +95 this month",
    detail: {
      kpis: [
        {
          icon: "✈️",
          gradient: "blue",
          label: "Missions Completed",
          value: "13",
          sub: "↑ 2 this quarter",
        },
        {
          icon: "⏱️",
          gradient: "green",
          label: "Hours Donated",
          value: "89 h",
          sub: "↑ 4 h this month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Avg Pts / Mission",
          value: "354",
          sub: "Building momentum",
        },
      ],
      missions: missionHistoryPilot,
      compare: comparePilot,
      badges: [],
      compareShortName: "Tom",
    },
  },
];

const missionHistoryAirport = [
  {
    date: "Mar 27, 2026",
    label: "Ramp support — Medevac Phoenix",
    points: "+620",
    hours: "—",
    status: "complete",
  },
  {
    date: "Mar 20, 2026",
    label: "Fuel grant — Angel Flight leg",
    points: "+540",
    hours: "—",
    status: "complete",
  },
  {
    date: "Mar 12, 2026",
    label: "Hangar day — maintenance volunteers",
    points: "+310",
    hours: "—",
    status: "complete",
  },
];

const badgesAirport = [
  { icon: "🛬", name: "Top Ramp", sub: "Q1 2026" },
  { icon: "⛽", name: "40K gal+", sub: "Fuel milestone" },
];

export const demoAirports = [
  {
    id: "a1",
    rank: 1,
    name: "Tucson Executive Airport",
    sub: "KTUS · Tucson, AZ",
    missions: "42",
    fuelGal: "8,240",
    score: "19,850",
    location: "Tucson, AZ",
    icao: "KTUS",
    rankLabel: "Tier 1 Partner",
    scoreDelta: "↑ +1.2K this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Supported",
          value: "42",
          sub: "↑ 6 this month",
        },
        {
          icon: "⛽",
          gradient: "green",
          label: "Fuel Donated (gal)",
          value: "8,240",
          sub: "↑ 400 gal vs avg",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Impact Score",
          value: "19,850",
          sub: "↑ peer airports",
        },
      ],
      missions: missionHistoryAirport,
      compare: {
        missions: [
          { label: "This airport", widthPct: 92, value: "42" },
          { label: "Network Avg", widthPct: 48, value: "22", variant: "avg" },
          { label: "Top 10%", widthPct: 70, value: "32", variant: "top" },
        ],
        score: [
          { label: "This airport", widthPct: 96, value: "20K" },
          { label: "Network Avg", widthPct: 40, value: "8.1K", variant: "avg" },
          { label: "Top 10%", widthPct: 75, value: "15K", variant: "top" },
        ],
      },
      badges: badgesAirport,
      compareShortName: "Tucson",
    },
  },
  {
    id: "a2",
    rank: 2,
    name: "High Desert Regional",
    sub: "KVCV · Victorville, CA",
    missions: "37",
    fuelGal: "7,110",
    score: "17,204",
    location: "Victorville, CA",
    icao: "KVCV",
    rankLabel: "Tier 1 Partner",
    scoreDelta: "↑ +980 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Supported",
          value: "37",
          sub: "Strong month",
        },
        {
          icon: "⛽",
          gradient: "green",
          label: "Fuel Donated (gal)",
          value: "7,110",
          sub: "↑ steady",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Impact Score",
          value: "17,204",
          sub: "#2 network",
        },
      ],
      missions: missionHistoryAirport,
      compare: {
        missions: [
          { label: "This airport", widthPct: 82, value: "37" },
          { label: "Network Avg", widthPct: 48, value: "22", variant: "avg" },
          { label: "Top 10%", widthPct: 70, value: "32", variant: "top" },
        ],
        score: [
          { label: "This airport", widthPct: 85, value: "17K" },
          { label: "Network Avg", widthPct: 40, value: "8.1K", variant: "avg" },
          { label: "Top 10%", widthPct: 75, value: "15K", variant: "top" },
        ],
      },
      badges: [badgesAirport[0]],
      compareShortName: "High",
    },
  },
  {
    id: "a3",
    rank: 3,
    name: "Santa Fe Municipal",
    sub: "KSAF · Santa Fe, NM",
    missions: "31",
    fuelGal: "5,980",
    score: "14,890",
    location: "Santa Fe, NM",
    icao: "KSAF",
    rankLabel: "Tier 2 Partner",
    scoreDelta: "↑ +720 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Supported",
          value: "31",
          sub: "On track",
        },
        {
          icon: "⛽",
          gradient: "green",
          label: "Fuel Donated (gal)",
          value: "5,980",
          sub: "Consistent",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Impact Score",
          value: "14,890",
          sub: "Top quartile",
        },
      ],
      missions: missionHistoryAirport,
      compare: {
        missions: [
          { label: "This airport", widthPct: 68, value: "31" },
          { label: "Network Avg", widthPct: 48, value: "22", variant: "avg" },
          { label: "Top 10%", widthPct: 70, value: "32", variant: "top" },
        ],
        score: [
          { label: "This airport", widthPct: 72, value: "15K" },
          { label: "Network Avg", widthPct: 40, value: "8.1K", variant: "avg" },
          { label: "Top 10%", widthPct: 75, value: "15K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "Santa",
    },
  },
  {
    id: "a4",
    rank: 4,
    name: "Provo Municipal Airport",
    sub: "KPVU · Provo, UT",
    missions: "26",
    fuelGal: "4,820",
    score: "11,440",
    location: "Provo, UT",
    icao: "KPVU",
    rankLabel: "Tier 2 Partner",
    scoreDelta: "↑ +410 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Supported",
          value: "26",
          sub: "Growing",
        },
        {
          icon: "⛽",
          gradient: "green",
          label: "Fuel Donated (gal)",
          value: "4,820",
          sub: "↑ Q1",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Impact Score",
          value: "11,440",
          sub: "Solid",
        },
      ],
      missions: missionHistoryAirport,
      compare: {
        missions: [
          { label: "This airport", widthPct: 58, value: "26" },
          { label: "Network Avg", widthPct: 48, value: "22", variant: "avg" },
          { label: "Top 10%", widthPct: 70, value: "32", variant: "top" },
        ],
        score: [
          { label: "This airport", widthPct: 58, value: "11K" },
          { label: "Network Avg", widthPct: 40, value: "8.1K", variant: "avg" },
          { label: "Top 10%", widthPct: 75, value: "15K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "Provo",
    },
  },
  {
    id: "a5",
    rank: 5,
    name: "Bozeman Yellowstone Intl",
    sub: "KBZN · Bozeman, MT",
    missions: "19",
    fuelGal: "3,650",
    score: "8,910",
    location: "Bozeman, MT",
    icao: "KBZN",
    rankLabel: "Tier 2 Partner",
    scoreDelta: "↑ +220 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Supported",
          value: "19",
          sub: "Seasonal peak",
        },
        {
          icon: "⛽",
          gradient: "green",
          label: "Fuel Donated (gal)",
          value: "3,650",
          sub: "Winter ops",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Impact Score",
          value: "8,910",
          sub: "Regional hub",
        },
      ],
      missions: missionHistoryAirport,
      compare: {
        missions: [
          { label: "This airport", widthPct: 45, value: "19" },
          { label: "Network Avg", widthPct: 48, value: "22", variant: "avg" },
          { label: "Top 10%", widthPct: 70, value: "32", variant: "top" },
        ],
        score: [
          { label: "This airport", widthPct: 46, value: "8.9K" },
          { label: "Network Avg", widthPct: 40, value: "8.1K", variant: "avg" },
          { label: "Top 10%", widthPct: 75, value: "15K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "Bozeman",
    },
  },
];

const missionHistoryNP = [
  {
    date: "Mar 29, 2026",
    label: "Coordinated wing — LA to Sacramento",
    points: "+890",
    hours: "—",
    status: "complete",
  },
  {
    date: "Mar 21, 2026",
    label: "Patient intake — oncology transfer",
    points: "+760",
    hours: "—",
    status: "complete",
  },
  {
    date: "Mar 10, 2026",
    label: "Disaster staging — supplies",
    points: "+650",
    hours: "—",
    status: "active",
  },
];

const badgesNP = [
  { icon: "🏥", name: "500+ patients", sub: "All-time" },
  { icon: "🚑", name: "Rapid Response", sub: "2026" },
];

export const demoNonprofits = [
  {
    id: "n1",
    rank: 1,
    name: "Angel Flight West",
    sub: "Patient Transport · CA",
    missions: "64",
    patients: "218",
    score: "24,320",
    location: "Los Angeles, CA",
    niche: "Patient Transport",
    rankLabel: "National partner",
    scoreDelta: "↑ +2.1K this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Coordinated",
          value: "64",
          sub: "↑ 9 vs avg",
        },
        {
          icon: "🚑",
          gradient: "green",
          label: "Patients Served",
          value: "218",
          sub: "↑ 12% QoQ",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Program Score",
          value: "24,320",
          sub: "#1 national",
        },
      ],
      missions: missionHistoryNP,
      compare: {
        missions: [
          { label: "This org", widthPct: 95, value: "64" },
          { label: "Network Avg", widthPct: 45, value: "30", variant: "avg" },
          { label: "Top 10%", widthPct: 78, value: "52", variant: "top" },
        ],
        score: [
          { label: "This org", widthPct: 98, value: "24K" },
          { label: "Network Avg", widthPct: 42, value: "9.8K", variant: "avg" },
          { label: "Top 10%", widthPct: 80, value: "19K", variant: "top" },
        ],
      },
      badges: badgesNP,
      compareShortName: "Angel",
    },
  },
  {
    id: "n2",
    rank: 2,
    name: "LiftLine Relief",
    sub: "Disaster Relief · TX",
    missions: "51",
    patients: "184",
    score: "19,888",
    location: "Dallas, TX",
    niche: "Disaster Relief",
    rankLabel: "Rapid deploy",
    scoreDelta: "↑ +1.4K this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Coordinated",
          value: "51",
          sub: "Strong",
        },
        {
          icon: "🚑",
          gradient: "green",
          label: "Patients Served",
          value: "184",
          sub: "Steady growth",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Program Score",
          value: "19,888",
          sub: "Top tier",
        },
      ],
      missions: missionHistoryNP,
      compare: {
        missions: [
          { label: "This org", widthPct: 78, value: "51" },
          { label: "Network Avg", widthPct: 45, value: "30", variant: "avg" },
          { label: "Top 10%", widthPct: 78, value: "52", variant: "top" },
        ],
        score: [
          { label: "This org", widthPct: 82, value: "20K" },
          { label: "Network Avg", widthPct: 42, value: "9.8K", variant: "avg" },
          { label: "Top 10%", widthPct: 80, value: "19K", variant: "top" },
        ],
      },
      badges: [badgesNP[1]],
      compareShortName: "LiftLine",
    },
  },
  {
    id: "n3",
    rank: 3,
    name: "Wings of Mercy",
    sub: "Medical Transport · MI",
    missions: "44",
    patients: "156",
    score: "17,160",
    location: "Grand Rapids, MI",
    niche: "Medical Transport",
    rankLabel: "Great Lakes hub",
    scoreDelta: "↑ +890 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Coordinated",
          value: "44",
          sub: "Consistent",
        },
        {
          icon: "🚑",
          gradient: "green",
          label: "Patients Served",
          value: "156",
          sub: "↑ month",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Program Score",
          value: "17,160",
          sub: "Elite quartile",
        },
      ],
      missions: missionHistoryNP,
      compare: {
        missions: [
          { label: "This org", widthPct: 68, value: "44" },
          { label: "Network Avg", widthPct: 45, value: "30", variant: "avg" },
          { label: "Top 10%", widthPct: 78, value: "52", variant: "top" },
        ],
        score: [
          { label: "This org", widthPct: 72, value: "17K" },
          { label: "Network Avg", widthPct: 42, value: "9.8K", variant: "avg" },
          { label: "Top 10%", widthPct: 80, value: "19K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "Wings",
    },
  },
  {
    id: "n4",
    rank: 4,
    name: "Pilots N Paws",
    sub: "Animal Rescue · NC",
    missions: "38",
    patients: "142",
    score: "14,820",
    location: "Charlotte, NC",
    niche: "Animal Rescue",
    rankLabel: "Southeast",
    scoreDelta: "↑ +640 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Coordinated",
          value: "38",
          sub: "Growing",
        },
        {
          icon: "🚑",
          gradient: "green",
          label: "Rescues Facilitated",
          value: "142",
          sub: "↑ fosters",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Program Score",
          value: "14,820",
          sub: "Momentum",
        },
      ],
      missions: missionHistoryNP,
      compare: {
        missions: [
          { label: "This org", widthPct: 58, value: "38" },
          { label: "Network Avg", widthPct: 45, value: "30", variant: "avg" },
          { label: "Top 10%", widthPct: 78, value: "52", variant: "top" },
        ],
        score: [
          { label: "This org", widthPct: 62, value: "15K" },
          { label: "Network Avg", widthPct: 42, value: "9.8K", variant: "avg" },
          { label: "Top 10%", widthPct: 80, value: "19K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "PNP",
    },
  },
  {
    id: "n5",
    rank: 5,
    name: "Sky Hope Network",
    sub: "Humanitarian Aid · TX",
    missions: "29",
    patients: "98",
    score: "11,310",
    location: "Houston, TX",
    niche: "Humanitarian Aid",
    rankLabel: "Gulf region",
    scoreDelta: "↑ +330 this month",
    detail: {
      kpis: [
        {
          icon: "🎯",
          gradient: "blue",
          label: "Missions Coordinated",
          value: "29",
          sub: "Stable",
        },
        {
          icon: "🚑",
          gradient: "green",
          label: "Beneficiaries",
          value: "98",
          sub: "Aid missions",
        },
        {
          icon: "⭐",
          gradient: "orange",
          label: "Program Score",
          value: "11,310",
          sub: "Building",
        },
      ],
      missions: missionHistoryNP,
      compare: {
        missions: [
          { label: "This org", widthPct: 48, value: "29" },
          { label: "Network Avg", widthPct: 45, value: "30", variant: "avg" },
          { label: "Top 10%", widthPct: 78, value: "52", variant: "top" },
        ],
        score: [
          { label: "This org", widthPct: 48, value: "11K" },
          { label: "Network Avg", widthPct: 42, value: "9.8K", variant: "avg" },
          { label: "Top 10%", widthPct: 80, value: "19K", variant: "top" },
        ],
      },
      badges: [],
      compareShortName: "Sky",
    },
  },
];

/** Map optional entity id → highlight row in airport / nonprofit portal views */
export function findDemoAirportByEntityId(entityId) {
  if (entityId == null || entityId === "") return null;
  const id = String(entityId).toUpperCase();
  return demoAirports.find((a) => String(a.icao).toUpperCase() === id) || null;
}

export function findDemoNonprofitByEntityId(entityId) {
  if (entityId == null || entityId === "") return null;
  return demoNonprofits.find((n) => n.id === entityId) || null;
}
